import { getCurrentCulture } from '@src/shared/lib/culture';
import type { Nullable } from '@src/shared/types/common';

import type { AjaxData, CallbackFunc } from '../types/utils/ajax';

export function ajaxPost(
    url: RequestInfo,
    data: AjaxData = null,
    doneFunc: CallbackFunc = null,
    failFunc: CallbackFunc = null,
    alwaysFunc: CallbackFunc = null
) {
    fetchRequest(url, data, 'POST', doneFunc, failFunc, alwaysFunc);
}

export function ajaxGet(
    url: RequestInfo,
    data: AjaxData = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'GET', doneFunc, failFunc, alwaysFunc);
}

export function ajaxPut(
    url: RequestInfo,
    data: AjaxData = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'PUT', doneFunc, failFunc, alwaysFunc);
}

export function ajaxDelete(
    url: RequestInfo,
    data: AjaxData = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'DELETE', doneFunc, failFunc, alwaysFunc);
}

function fetchRequest(
    url: RequestInfo,
    data: AjaxData,
    type: 'POST' | 'DELETE' | 'GET' | 'PUT',
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    let body: Nullable<string> = null;
    if (type === 'GET' || type === 'DELETE') {
        if (typeof url === 'string') {
            if (!url.endsWith('?') && data) {
                url += '?';
            }

            url += data ? jQuery.param(data) : '';
        }
    }
    else {
        body = JSON.stringify(data);
    }

    fetch(url, {
        method: type,
        body: body,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'Accept': 'application/json',
            'X-Timezone': (-(new Date().getTimezoneOffset() / 60)).toString(),
            'Accept-Language': getCurrentCulture()
        }
    })
        .then(async (response) => {
            if (response.status === 200) {
                const responseJson = await response.json();
                await doneFunc?.(responseJson);
            }
            else {
                const responseText = await response.text();
                await failFunc?.(responseText);
            }

            await alwaysFunc?.(response);
        })
        .catch(async (error: unknown) => {
            const userError = 'Серверная ошибка.';
            console.error(error);
            await failFunc?.(userError);
            await alwaysFunc?.(userError);
        });
}

window.ajaxGet = ajaxGet;
window.ajaxPost = ajaxPost;
window.ajaxDelete = ajaxDelete;
window.ajaxPut = ajaxPut;
